module.exports = {
      id: "breaking-news-usage",
      viewBox: "0 0 25 25",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#breaking-news",
      toString: function () {
        return this.url;
      }
    }